import { useState, useEffect } from 'react';
import Logger from '../libs/logger';

interface UseFLifecycleResult {
  phase: number | string;
}

export const useLifecycle = (componentName: string): UseFLifecycleResult => {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    setPhase((p) => p + 1);
    return () => Logger.info(`FC::${componentName}-Unmount`);
  }, [componentName]);
  Logger.info([`FC::${componentName}`, phase]);
  return { phase };
};

export default useLifecycle;
